import { Component } from '@angular/core';
import { FieldTypeConfig } from '@ngx-formly/core';
import { FieldType } from '@ngx-formly/material';

@Component({
  selector: 'padded-label',
  template: `
  <div class="tw-pb-2">
    <mat-label>{{to.label}}</mat-label>
  </div>
  `,
  styles: []
})

export class LabelComponent extends FieldType<FieldTypeConfig> {

}
